import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import {
  DueReminderKind,
  ManualSmsPreviewResponse,
  SendManualSmsReminderRequest,
  SendManualSmsReminderResult,
} from '../../models/vehicle-sms-reminder.interface';

// Mock-mode handler for /:tenantId/vehicles/:vehicleId/sms-reminder/{preview,send}.
// The wording mirrors the API template variants so offline screens look real.
// Routed BEFORE the generic /vehicles mock, which would otherwise swallow it.
const DUE_LABEL: Record<DueReminderKind, string> = {
  WOF: 'a WOF',
  SERVICE: 'a service',
  BOTH: 'a WOF and service',
};

@Injectable({ providedIn: 'root' })
export class VehicleSmsReminderMocksService {
  handleMockRequest(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (req.method === 'GET' && req.url.includes('/sms-reminder/preview')) {
      return this.preview(req);
    }
    if (req.method === 'POST' && req.url.includes('/sms-reminder/send')) {
      return this.send(req.body as SendManualSmsReminderRequest);
    }
    throw new Error(`Unsupported mock sms-reminder request: ${req.method} ${req.url}`);
  }

  private preview(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    const url = new URL(req.url);
    const segments = url.pathname.split('/');
    const vehicleId = parseInt(segments[segments.indexOf('vehicles') + 1] || '1', 10);
    const kind = (url.searchParams.get('reminderType') as DueReminderKind | null) ?? 'WOF';

    const body = `Hi Sam Lee, Toyota Corolla (ABC123) is due for ${DUE_LABEL[kind]} at Maidstone Mechanical. Call 04 123 4567 to book.`;
    const response: ManualSmsPreviewResponse = {
      vehicleId,
      smsEnabled: true,
      customer: { id: 7, name: 'Sam Lee', mobilePhone: '022 457 5570', smsConsent: false },
      activeReminders: [{ reminderType: 'WOF', dueDate: '2026-10-20' }],
      reminderType: kind,
      body,
      limits: { maxLength: 306, singleSegmentLength: 160, multiSegmentLength: 153 },
      segments: { count: 1, length: body.length },
    };
    return of(new HttpResponse({ status: 200, body: response })).pipe(delay(300));
  }

  private send(request: SendManualSmsReminderRequest): Observable<HttpEvent<any>> {
    const result: SendManualSmsReminderResult = {
      outcome: 'SENT',
      skipReason: null,
      messageSid: 'mock-sid-001',
      sentToMasked: request.mobileOverride ? '+64••••••234' : '+64••••••570',
      segments: 1,
    };
    return of(new HttpResponse({ status: 200, body: result })).pipe(delay(500));
  }
}
